import { useMemo } from "react";

import type { Domain } from "~/api/Api";

import { DnsPayloadRow, DnsRecordData } from "../types";
import RecordsTable from "./RecordsTable";

function mapSystemConfigToRows(cfg: (string | number)[][]): DnsRecordData[] {
  if (!cfg?.length) return [];

  return cfg.map((item, index) => {
    const [name, ttl, type, content] = item as DnsPayloadRow;

    return {
      id: index,
      type: String(type ?? ""),
      nameFQDN: String(name ?? ""),
      host: "",
      content: String(content ?? ""),
      ttl: Number(ttl ?? 0),
    };
  });
}

export default function SystemConfigTable({ domain }: { domain: Domain }) {
  const rows = useMemo(
    () => mapSystemConfigToRows(domain?.system_config || []),
    [domain?.system_config],
  );

  return <RecordsTable rows={rows} domainName={domain?.name} />;
}
